// components/FormField.jsx
import React, { useState } from 'react';
import { useTheme } from '../../themes/ThemeProvider';

const FormField = ({
  type = 'text',
  label,
  value,
  onChange,
  min,
  max,
  step,
  options,
  className = '',
  placeholder,
  onLabelClick,
  disabledOptions = [],
  ...props
}) => {
  const { theme } = useTheme(); // Access theme from context
  const [labelClickZone, setLabelClickZone] = useState(onLabelClick ? true : false);

  // Render the appropriate input based on the type
  const renderInput = () => {
    // Base input class from theme
    const inputClass = theme?.input || 'bg-gray-700 border-gray-600 text-white';
    const checkboxClass = theme?.checkbox || '';

    switch (type) {
      case 'textarea':
        return (
          <textarea
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            rows={3}
            className={`break-all flex-grow px-1 py-1 rounded-md border outline-none ${inputClass} ${className}`}
            {...props}
          />
        );
      
      case 'range':
        return (
          <div className="flex flex-row justify-center items-center">
            <input
              type="range"
              min={min}
              max={max}
              step={step}
              value={value || 0}
              placeholder={placeholder}
              onChange={(e) => onChange(e.target.value)}
              className={`w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer ${className}`}
              {...props}
            />
            <span className={`flex justify-end text-right text-xs text-gray-400 w-8`}>
                {value || 50}
                {props.unit || ''}
            </span>
          </div>
        );
      
      case 'checkbox':
        return (
          <div className={`${checkboxClass}`}>
            <input
              type="checkbox"
              checked={value || false}
              placeholder={placeholder}
              onChange={(e) => onChange(e.target.checked)}
              className={`cursor-pointer ${className}`}
              {...props}
            />
          </div>
        );
      
      // case 'select':
      //   return (
      //     <select
      //       value={value || ''}
      //       placeholder={placeholder}
      //       onChange={(e) => onChange(e.target.value)}
      //       className={`${inputClass} ${className}`}
      //       {...props}
      //     >
      //       {options.map((option) => (
      //         <option
      //           key={option.value}
      //           value={option.value}
      //           disabled={disabledOptions.includes(option.value)}
      //         >
      //           {option.label}
      //         </option>
      //       ))}
      //     </select>
      //   );
      case 'select':
        return (
          <select
            value={value || ''}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
            className={`${inputClass} ${className}`}
            {...props}
          >
            {options && typeof options === 'object' && Object.entries(options).map(([key, label]) => (
              <option
                key={key}
                value={key}
                disabled={disabledOptions.includes(key)}
              >
                {label}
              </option>
            ))}
          </select>
        );

      default:
        return (
          <input
            type={type}
            value={value || ''}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
            className={`${inputClass} ${className}`}
            {...props}
          />
        );
    }
  };

  // Get label class from theme
  const labelClass = type === "checkbox" ? theme?.chckbxLabel : theme?.label || 'text-gray-100';

  return (
    <div className={`${theme.fieldCombo}`}>
      {label && (
        <span
          className={`${labelClass} ${onLabelClick ? "cursor-pointer" : ""}`}
          onClick={onLabelClick}
        >
          {label}
        </span>
      )}
        {renderInput()}
    </div>
  );
};

export default FormField;